<template>
    <router-link
        :to="to"
        custom
        v-slot="{ href, route, navigate, isActive, isExactActive }"
    >
        <a :href="href"
           v-bind="$attrs"
           @click="navigate"
           class="flex justify-center flex-grow transition-colors duration-300 items-center menu_button"
           :class="[isExactActive ? 'bg-next-light-gray hover:bg-next-light-gray text-next-orange': 'text-white hover:bg-next-neu']">
            <slot>
                <i class="text-2xl" :class="iconClass"></i>
            </slot>
            <span v-if="tooltip" class="tooltip">
                <span class="tooltiptext">{{ tooltip }}</span>
            </span>
        </a>
    </router-link>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'MenuButton',
    props: {
        to: {
            type: [Object,String]
        },
        iconClass:String,
        tooltip:String,
        id: String,
    }
})
export default class MenuButton extends Vue {
    to!:any
    id!:String
    tooltip!:String
    iconClass!:String
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tooltip {
    padding-left: 100%;
    position: absolute;
    display: inline-block;
}

.tooltip .tooltiptext {
    font-size: .8rem;
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 100000;
    transform: translate(10px,-50%);
    opacity: 0;
    transition: opacity 0.3s;
    transition-delay: .5s;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -10px;
    margin-top: -4px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent #555 transparent transparent;
}

.menu_button:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}
</style>
